import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../images/new_logo.png';

const Header = ({ user, onLoginClick, onSignupClick }) => {
  const { logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  };

  const handleAuthClick = (authType) => {
    setIsMenuOpen(false);
    if (authType === 'login') {
      onLoginClick && onLoginClick();
    } else if (authType === 'signup') {
      onSignupClick && onSignupClick();
    }
  };

  // const handleSettings = () => {
  //   // Placeholder for settings functionality
  //   alert('Settings functionality coming soon!');
  //   setIsMenuOpen(false);
  // };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <Link to="/" className="logo-text">
            <img src={logo} alt="BullBearly Logo" className="logo" />
            <span className="logo-text-split">
              <span className="logo-bull">BULL</span>
              <span className="logo-bearly">BEARLY</span>
            </span>
          </Link>
        </div>
        
        <div className="user-menu">
          {user ? (
            <>
              <span className="user-name">Welcome, {user.fullName}</span>
              <span className="user-role">{user.role}</span>
              <div className="menu-container">
                <button 
                  className="menu-button"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  Menu ▼
                </button>
                
                {isMenuOpen && (
                  <div className="dropdown-menu">
                    <Link 
                      to="/settings" 
                      className="dropdown-item"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      ⚙️ Settings
                    </Link>
                    <Link 
                      to="/settings?tab=profile" 
                      className="dropdown-item"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      👤 Profile
                    </Link>
                    <button 
                      className="dropdown-item"
                      onClick={handleLogout}
                      style={{ 
                        background: 'none', 
                        border: 'none', 
                        width: '100%', 
                        textAlign: 'left',
                        cursor: 'pointer'
                      }}
                    >
                      🚪 Logout
                    </button>
                  </div>
                )}
              </div>
            </>
                 ) : (
                   <div className="auth-buttons">
                     <button 
                       className="auth-button signup-button"
                       onClick={() => handleAuthClick('login')}
                     >
                       Sign Up / Sign In
                     </button>
                   </div>
                 )}
        </div>
      </div>
    </header>
  );
};

export default Header;
